import React, { Fragment, FunctionComponent, useState } from 'react';
import style from './TextFieldIcon.module.scss';
import { FieldValidatorType, FieldWrapper } from '@progress/kendo-react-form';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import { BrassField, BrassFieldProps } from '../Field';
import { BrassInput, BrassInputProps } from '../../../inputs/Input';
import { BrassError } from '../../../labels/Error';
import { BrassLoader } from '../../../indicators';
import { requiredValidator } from '../validators/required';
import { Label } from '@progress/kendo-react-labels';
import { translate } from './TextFieldIcon.translations';

interface TextFieldIconInputProps extends BrassInputProps {
  value?: string;
  visited: boolean;
  maxLength?: number;
  disabled?: boolean;
  onBlurInternal?: () => void;
}

const TextFieldInputIcon: FunctionComponent<TextFieldIconInputProps> = (
  fieldRenderProps: any,
): any => {
  const {
    maxLength,
    validationMessage,
    value,
    disabled,
    onChange,
    visited,
    onBlurInternal,
  } = fieldRenderProps;

  const [internalValue, setInternalValue] = useState<string>(value || '');
  const onInternalChange = (e: InputChangeEvent): void => {
    if (onChange) {
      onChange(e);
    }
    setInternalValue(e.value);
  };

  return (
    <Fragment>
      <BrassInput
        className={style.input}
        {...fieldRenderProps}
        disabled={disabled}
        onChange={onInternalChange}
        onBlur={onBlurInternal}
      />
      {visited && validationMessage && <BrassError>{validationMessage}</BrassError>}
      {maxLength && !validationMessage && (
        <div className={style['div-messages-info']}>
          {internalValue.length || 0} / {maxLength}
        </div>
      )}
    </Fragment>
  );
};

interface BrassTextFieldIconProps
  extends Omit<BrassFieldProps & TextFieldIconInputProps, 'valid,component'> {
  name?: string;
  label?: string;
  icon?: any;
  loading?: boolean;
  disabled?: boolean;
  validator?: FieldValidatorType[];
  showIcon?: boolean;
  onBlurInternal?: () => void;
}

const BrassTextFieldIcon: FunctionComponent<BrassTextFieldIconProps> = (
  props: any,
) => {
  const { name, required, loading, validator, showIcon, onBlurInternal } = props;
  const [isIcon, setIsIcon] = useState(showIcon ?? true);
  const validators = validator && validator.length ? [...validator] : [];
  if (required) {
    validators.push(requiredValidator);
  }

  if (loading) {
    return (
      <BrassField
        {...props}
        disabled
        name={name!}
        component={<BrassInput onBlurInternal={onBlurInternal} {...props} />}
        defaultValue={translate('loadingData')}
      />
    );
  }

  return (
    <FieldWrapper>
      <Label className={style.label}>
        {isIcon && <div className={style.icon}> {props.icon}</div>}
        {required ? `${props.label}*` : props.label}
      </Label>
      <BrassField
        {...props}
        name={name!}
        validator={validators}
        component={loading ? () => <BrassLoader /> : TextFieldInputIcon}
        label={undefined /* required ? `${props.label}*` : props.label */}
      />
    </FieldWrapper>
  );
};

export { BrassTextFieldIcon };
export type { BrassTextFieldIconProps };
